export type SafeExceptionInfo = {
  code?: string | number;
  status?: number;
  type?: string;
};

export class SerializableException {
  constructor(readonly code: string) {}
}

export class ServiceNotFoundException extends SerializableException {
  readonly type = 'NotFoundException';
}

export class ServiceConflictException extends SerializableException {
  readonly type = 'ConflictException';
}

export class ServiceValidationException extends SerializableException {
  readonly type = 'ValidationException';
}

export class ServiceImmutableResourceException extends SerializableException {
  readonly type = 'ImmutableResourceException';
}

export class ServiceConfigurationException extends SerializableException {
  readonly type = 'ConfigurationException';
}

export class ServiceNoUserException extends SerializableException {
  constructor() {
    super('NO_USER');
  }
  readonly type = 'NoUserException';
}

export class ServiceNoTokenException extends SerializableException {
  constructor() {
    super('NO_TOKEN');
  }
  readonly type = 'NoTokenException';
}

export class ServiceInvalidTokenException extends SerializableException {
  constructor() {
    super('INVALID_TOKEN');
  }
  readonly type = 'InvalidTokenException';
}

export class ServiceUnauthorizedException extends SerializableException {
  constructor() {
    super('UNAUTHORIZED');
  }
  readonly type = 'UnauthorizedException';
}

export class ServiceAuthenticateException extends SerializableException {
  readonly type = 'AuthenticateException';
}

export class SearchFailedException extends SerializableException {
  constructor() {
    super('SEARCH_FAILED');
  }
  readonly type = 'SearchFailedException';
}

export function convertErrorToException<E extends SafeExceptionInfo = SafeExceptionInfo>(
  err: unknown
): E {
  const obj = err && typeof err === 'object' ? (err as Record<string, unknown>) : {};
  const out: Record<string, unknown> = {};

  // Prefer err.code (ServiceValidationException, legacy AWS SDK v2) over err.name
  // (AWS SDK v3 errors use name instead of code, e.g. 'ResourceNotFoundException')
  if (typeof obj.code === 'string' || typeof obj.code === 'number') {
    out.code = obj.code;
  } else if (typeof obj.name === 'string') {
    out.code = obj.name;
  }
  if (typeof obj.status === 'number') out.status = obj.status;
  if (typeof obj.type === 'string') out.type = obj.type;

  return out as E;
}
